// ======================================================================
// File Name       : item
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';

export function postItemGetList(data) {
  return commonCallApi({
    path: 'item/GetList',
    data: { ...data },
  });
}

export function postItemEditDisplayOrder(data) {
  return commonCallApi({
    path: 'item/EditDisplayOrder',
    data,
  });
}

export function postItemEdit(data) {
  return commonCallApi({
    path: 'item/Edit',
    data,
  });
}
